import React from 'react';
import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import Description from '../text/Description';
import ProductCard from '../card/ProductCard';

import Image1 from '../../assets/image/collaboration_accessory/youring.png'
import Image2 from '../../assets/image/collaboration_accessory/primavera.png'
import Image3 from '../../assets/image/collaboration_accessory/felice.png'
import Image4 from '../../assets/image/collaboration_accessory/mariko.png'

const CollaborationDressWrapper = styled.section`
  
`;

const SectionCollaborationAccessory = () => {
    const text = 'PLACOLE＆DRESSY(プラコレ＆ドレシー)は\nこれまでに、様々なアクセサリーブランドや、\n人気の作家とコラボレーションをし\nオリジナルアクセサリーを発表してきました。';
    const url = "https://weddingdress.pla-cole.wedding/"
    const buttonText = '購入ページはこちら'

    const items =[
        {title: "youring（ユーリン）", image: Image1, url: "https://weddingdress.pla-cole.wedding/c/ring"},
        {title: "Primavera（プリマヴェーラ）", image: Image2, url: "https://weddingdress.pla-cole.wedding/c/original/original_accessory/primavera"},
        {title: "felice（フェリーチェ）", image: Image3, url: "https://weddingdress.pla-cole.wedding/c/original/original_accessory/felice"},
        {title: "MARIKO（マリコ）", image: Image4, url: "https://weddingdress.pla-cole.wedding/c/original/original_accessory/mariko"},
    ]

    return (
      <Wrapper id="collaboration-accessory">
        <CollaborationDressWrapper>
            <Title 
                title={"COLLABORATION ACCESSORY"}
                subTitle={"コラボリング・コラボアクセサリー"}    
            />
            <Description text={text} />
            {items.map((item, index) => (
                <ProductCard 
                    key={index}
                    title={item.title}
                    image={item.image}
                    url={item.url}
                    buttonText={buttonText}
                />
            ))}
        </CollaborationDressWrapper>
      </Wrapper>
    );
  };
  
export default SectionCollaborationAccessory;
  